<template>
  <div class="project-team">
    <el-table :data="paginationData" style="width: 100%" v-loading="loading">

      <el-table-column prop="deptName" label="所属公司" width="180px">
      </el-table-column>
      <el-table-column prop="number" label="项目编号" width="120px">
      </el-table-column>
      <el-table-column prop="name" label="项目名称" width="200px">
      </el-table-column>
      <el-table-column prop="status" label="项目状态">
      </el-table-column>
      <el-table-column prop="leader.name" label="项目负责人">
      </el-table-column>
      <el-table-column prop="leader.mobile" label="联系方式">
      </el-table-column>

      <el-table-column label="操作" width="80px">
        <template slot-scope="scope">
          <router-link target="_blank" :to='"/Project/Detail/" + scope.row.id'>
            <el-button plain size="mini">详情</el-button>
          </router-link>
        </template>
      </el-table-column>

    </el-table>
    <el-pagination v-if="filterData.length>pageSize" class="list-pagination" background :page-size="pageSize"
      :pager-count="9" :current-page="currentPage" layout="pager" :total="filterData.length"
      @current-change="handleCurrentChange">
    </el-pagination>

  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";
  export default {
    props: ['projectId'],
    computed: {
      ...mapState({
        userData: state => state.main.userData,
        organization: state => state.main.organization,
      })
    },
    data() {
      return {
        depId: '',
        department: '',
        // 列表
        loading: true,
        pageSize: 20,
        currentPage: 1,
        listData: [],
        filterData: [],
        paginationData: [],
      }
    },
    created() {
      this.department = this.userData.department.split('/')[0]
      this.depId = this.userData.secDepIds.split(",")[0] / 1
    },
    mounted() {
      // 获取列表
      this.getLists()
    },
    components: {},
    methods: {
      projectDetail(row) {
        this.$router.push("/Project/Detail/" + row.id)
      },
      startCreate() {
        this.$router.push("/Project/Create")
      },
      // 当前页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPaginationData()
      },
      // 搜索筛选新闻数据
      getFilterData() {
        console.log(this.filterName)
        if (this.filterName) {
          // 筛选出所有符合的数据
          this.filterData = []
          for (let i = 0; i < this.listData.length; i++) {
            let _new = this.listData[i]
            if (_new.name.indexOf(this.filterName) != -1) {
              this.filterData.push(_new)
            }
          }
        } else {
          this.filterData = this.listData
        }
        this.currentPage = 1
        this.getPaginationData()
      },
      // 分页筛选数据
      getPaginationData() {
        if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
          this.currentPage = Math.ceil(this.filterData.length / this.pageSize)
        }
        if (this.currentPage == 0) {
          this.currentPage = 1
        }
        // 分页筛选
        this.paginationData = this.filterData.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this
          .currentPage)
      },
      // 获取列表
      getLists() {
        ajax.get('/gc/project/relate/projects/' + this.projectId, '', (res) => {
          this.loading = false
          this.filterData = this.listData = res.vo.array
          this.getPaginationData()
        })
      },
    },
    watch: {}
  };
</script>


// WEBPACK FOOTER //
// src/page/project/team.vue